import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CityProvider } from "./context/CityContext";
import { LangProvider } from "./context/LangContext";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFab from "./components/WhatsAppFab";
import CityPickerModal from "./components/CityPickerModal";
import LaunchBanner from "./components/LaunchBanner";
import Landing from "./pages/Landing";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import SignupQuick from "./pages/SignupQuick";
import PayUpi from "./pages/PayUpi";
import PartnerEarning from "./pages/PartnerEarning";
import HomeStay from "./pages/HomeStay";
import HomeStayOwner from "./pages/HomeStayOwner";
import { ForgotPassword, ResetPassword } from "./pages/PasswordReset";
import HomeStayProperty from "./pages/HomeStayProperty";
import MyStay from "./pages/MyStay";
import Dashboard from "./pages/Dashboard";
import Membership from "./pages/Membership";
import About from "./pages/About";
import BecomeMate from "./pages/BecomeMate";
import CorporateEnquiry from "./pages/CorporateEnquiry";
import Earn from "./pages/Earn";
import EarnByHelping from "./pages/EarnByHelping";
import RailLuggageAssist from "./pages/RailLuggageAssist";
import NameCraft from "./pages/NameCraft";
import {
  FlatmateLanding, FlatmateOnboard, FlatmateBrowse, FlatmateListingDetail,
  FlatmateList, FlatmateJourney, FlatmatePay, FlatmateDashboard, FlatmateRefunds,
  FlatmateVerify,
} from "./pages/Flatmate";
import { HelperTasks, HelperTaskDetail } from "./pages/Helper";
import Partner from "./pages/Partner";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import SplashScreen from "./components/SplashScreen";
import SplashLead from "./components/SplashLead";
import FreeHelpMascot from "./components/FreeHelpMascot";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

function AppRoutes() {
  const location = useLocation();
  // Emergent OAuth returns to <redirect>#session_id=... — must be handled BEFORE anything else
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<ServiceDetail />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/homestay/p/:pid" element={<HomeStayProperty />} />
      <Route path="/homestay/my-stay" element={<MyStay />} />
      <Route path="/register" element={<Register />} />
      <Route path="/signup-quick" element={<SignupQuick />} />
      <Route path="/quick-signup" element={<SignupQuick />} />
      <Route path="/pay-upi" element={<PayUpi />}  />
      <Route path="/partner-earning" element={<PartnerEarning />} />
      <Route path="/earn-partner" element={<PartnerEarning />} />
      <Route path="/homestay" element={<HomeStay />} />
      <Route path="/homestay/demo" element={<HomeStay />} />
      <Route path="/homestay/owner" element={<HomeStayOwner />} />
      <Route path="/homestay/owner/:tab" element={<HomeStayOwner />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/membership" element={<Membership />} />
      <Route path="/about" element={<About />} />
      <Route path="/become-mate" element={<BecomeMate />} />
      <Route path="/corporate" element={<CorporateEnquiry />} />
      <Route path="/earn" element={<Earn />} />
      <Route path="/earn-by-helping" element={<EarnByHelping />} />
      <Route path="/rail-luggage-assist" element={<RailLuggageAssist />} />
      <Route path="/coolie-finder" element={<RailLuggageAssist />} />
      <Route path="/namecraft" element={<NameCraft />} />
      <Route path="/flatmate" element={<FlatmateLanding />} />
      <Route path="/flatmate/onboard" element={<FlatmateOnboard />} />
      <Route path="/flatmate/browse" element={<FlatmateBrowse />} />
      <Route path="/flatmate/listing/:lid" element={<FlatmateListingDetail />} />
      <Route path="/flatmate/list" element={<FlatmateList />} />
      <Route path="/flatmate/journey" element={<FlatmateJourney />} />
      <Route path="/flatmate/pay" element={<FlatmatePay />} />
      <Route path="/flatmate/dashboard" element={<FlatmateDashboard />} />
      <Route path="/flatmate/verify" element={<FlatmateVerify />} />
      <Route path="/flatmate/refunds" element={<FlatmateRefunds />} />
      <Route path="/helper" element={<HelperTasks />} />
      <Route path="/helper/task/:jid" element={<HelperTaskDetail />} />
      <Route path="/partner" element={<Partner />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CityProvider>
          <LangProvider>
            <BrowserRouter>
              <SplashScreen />
              <SplashLead />
              <FreeHelpMascot />
              <LaunchBanner />
              <Navbar />
              <main className="min-h-[70vh]">
                <AppRoutes />
              </main>
              <Footer />
              <WhatsAppFab />
              <CityPickerModal />
              <Toaster position="top-center" richColors />
            </BrowserRouter>
          </LangProvider>
        </CityProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
